import React from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';

import AppErrorFallback, {
  defaultResetErrorBoundary,
} from 'components/GlobalErrorBoundary/AppErrorFallback';

const toError = (routeError: unknown): Error => {
  if (routeError instanceof Error) {
    return routeError;
  }

  if (isRouteErrorResponse(routeError)) {
    const responseDetails =
      typeof routeError.data === 'string'
        ? routeError.data
        : JSON.stringify(routeError.data);

    return new Error(
      `${routeError.status} ${routeError.statusText}${
        responseDetails ? `\n${responseDetails}` : ''
      }`,
    );
  }

  if (typeof routeError === 'string') {
    return new Error(routeError);
  }

  return new Error('Erro inesperado ao renderizar a rota.');
};

const RouterErrorFallback: React.FC = () => {
  const routeError = useRouteError();

  return (
    <AppErrorFallback
      error={toError(routeError)}
      errorInfo={null}
      resetErrorBoundary={defaultResetErrorBoundary}
    />
  );
};

export default RouterErrorFallback;
